import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  submissionId: number;
  updateSubmission: () => Promise<void>;
}

/**
 * Lets an owner or superadmin delete their own feedback submission, so they
 * can re-test the form after submitting it themselves. Participants never
 * see this - the API refuses the request for anyone else.
 */
const CalendarEventFeedbackSubmissionDelete = ({
  submissionId,
  updateSubmission
}: Props) => {
  const {
    messages,
    pageState: { calendarEvent }
  } = useReduxState();

  const handleConfirm = async () => {
    // the submissionId is required - without it, this route deletes
    // every submission for the event instead of just this one
    if (!submissionId) return false;

    await api.delete(
      `/admin/calendar-events/${calendarEvent.id}/feedback-submission/${submissionId}`
    );
    await updateSubmission();
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonCategory="danger"
      buttonIcon="trash-alt"
      buttonText={messages.eventCalendarFeedbackDeleteAnswers}
      buttonTooltip={messages.eventCalendarFeedbackDeleteAnswersTooltip}
      category="danger"
      confirmText={messages.eventCalendarFeedbackDeleteAnswersMessage}
      confirmTitle={messages.eventCalendarFeedbackDeleteAnswers}
      onConfirm={handleConfirm}
      successMessage={messages.eventCalendarFeedbackDeleteAnswersSuccess}
    />
  );
};

export default CalendarEventFeedbackSubmissionDelete;
